import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'dpl/shared/utils/object';
import SmartImage from 'dpl/components/SmartImage';
import RichText from 'dpl/prismic/components/RichText';

export default function SplashPhoto({ sliceData }) {
  const image = get(sliceData, 'primary.image');
  const caption = get(sliceData, 'primary.caption');

  return (
    <div className="PrismicSplashPhoto container">
      <div className="row">
        <div className="PrismicSplashPhoto__content col-lg-9 col-xl-11">
          <div className="f0">
            {image && (
              <SmartImage
                tag="div"
                src={image.url}
                alt={image.alt}
                lazy
                width={`${image.dimensions.width}px`}
                className="mw-100 h-100 bg-center cover"
              />
            )}
          </div>
          {caption && (
            <div className="tl mt3">
              <RichText content={caption} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

SplashPhoto.propTypes = {
  /**
   * Data has a key primary which then has two keys:
   *
   * 1) image: an object with a photo's URL and alt text
   *
   * 2) caption: a Prismic RichText object with the caption text and styling
   */
  sliceData: PropTypes.shape({
    primary: PropTypes.shape({
      image: PropTypes.shape({
        alt: PropTypes.string,
        url: PropTypes.string.isRequired,
        dimenstions: PropTypes.shape({
          width: PropTypes.string
        })
      }),
      caption: PropTypes.arrayOf(
        PropTypes.shape({
          type: PropTypes.string,
          text: PropTypes.string
        })
      )
    })
  }).isRequired
};
